<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'

const props = defineProps({
  required: {
    type: Boolean,
    default: true
  },
  id: {
    type: String,
    default: ''
  },
  label: {
    type: String,
    default: ''
  },
  checked: {
    type: Boolean,
    default: false,
  }
})

const emit = defineEmits(['updated'])

const isChecked = ref(props.checked)

watch(isChecked, (newValue) => {
  emit('updated', newValue)
})
</script>

<template>
  <div class="form-group">
    <div :class="['checkbox', { '-empty-but-required': !isChecked && props.required, '-checked': isChecked }]">
      <label :for="props.id" class="form-check-label">
        <input
          :id="props.id"
          type="checkbox"
          :required="props.required"
          v-model="isChecked"
        />
        <span class="meta" v-html="props.label"></span>
      </label>
    </div>
  </div>
</template>
